import { render, staticRenderFns } from "./GenericDevice.vue?vue&type=template&id=22b2007a&"
import script from "./GenericDevice.vue?vue&type=script&lang=js&"
export * from "./GenericDevice.vue?vue&type=script&lang=js&"
import style0 from "./GenericDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports